import type { AreaCatalog } from '../area';
import type { itemErrors as en } from '../en/itemErrors';

export const itemErrors = {
  // --- The contract commands (src/domain/state-machine.ts) ---------------------
  'itemErrors.contract.alreadyDelivered': 'Steht schon auf Fertig.',
  'itemErrors.contract.notDelivered': 'Steht nicht auf Fertig, es gibt nichts zurückzunehmen.',
  'itemErrors.contract.notClosed': 'Schon offen. Es gibt nichts wieder zu öffnen.',
  'itemErrors.contract.alreadyActive': 'Schon aktiv.',
  'itemErrors.contract.alreadyIdle': 'Schon ruhend.',
  'itemErrors.contract.alreadyContributor': 'Du bist schon zuständig.',
  'itemErrors.contract.noRequesterToAccept':
    'Ohne Verantwortliche gibt es niemanden, der die Arbeit abnehmen kann.',
  'itemErrors.contract.acceptNeedsDelivery': 'Abnehmen geht nur, wenn die Aufgabe fertig ist.',
  'itemErrors.contract.alreadyAccepted': 'Schon abgenommen.',
  'itemErrors.contract.noRequesterToDispute':
    'Ohne Verantwortliche gibt es niemanden, der die Abnahme verweigern kann.',
  'itemErrors.contract.disputeNeedsDelivery':
    'Die Abnahme verweigern geht nur, wenn die Aufgabe fertig ist.',
  'itemErrors.contract.alreadyDisputed': 'Abnahme schon verweigert.',
  'itemErrors.contract.noRequesterToResolve':
    'Ohne Verantwortliche gibt es niemanden, der die Bewertung zurückziehen kann.',
  'itemErrors.contract.noVerdict': 'Es gibt keine Bewertung zum Zurückziehen.',
  'itemErrors.contract.priorityUnchanged': 'Priorität unverändert.',
  'itemErrors.contract.criteriaUnchanged': 'Abnahmekriterien unverändert.',
  'itemErrors.contract.descriptionUnchanged': 'Beschreibung unverändert.',
  'itemErrors.contract.noteTooLong': 'Eine Notiz hat höchstens {max} Zeichen (hier {length}).',
  'itemErrors.contract.noteUnchanged': 'Notiz unverändert.',
  'itemErrors.contract.titleNeeded': 'Eine Aufgabe braucht einen Titel.',
  'itemErrors.contract.titleUnchanged': 'Titel unverändert.',
  'itemErrors.contract.visibilityUnchanged': 'Sichtbarkeit unverändert.',
  'itemErrors.contract.inheritanceUnchanged': 'Die Vererbung ist schon so eingestellt.',
  'itemErrors.contract.reviewRequiredUnchanged': 'Die Review ist schon so eingestellt.',
  'itemErrors.contract.requestersUnchanged': 'Verantwortliche unverändert.',
  'itemErrors.contract.alreadyOpen': 'Die Zuständigkeit ist schon offen.',
  'itemErrors.contract.contributorsUnchanged': 'Zuständige unverändert.',
  'itemErrors.contract.alreadyTagged': 'Schon mit #{tag} getaggt.',
  'itemErrors.contract.commentEmpty': 'Der Kommentar ist leer.',
  'itemErrors.contract.workItemTitleNeeded': 'Eine Aufgabe braucht einen Titel.',
  'itemErrors.contract.createKeyMalformed': 'Diese Erstellung trägt einen ungültigen Schlüssel.',
  'itemErrors.contract.createKeyReused': 'Dieser Schlüssel gehört schon zu einer anderen Aktion.',

  // --- Promises (src/domain/relationships.ts) ----------------------------------
  'itemErrors.promise.notADependency': 'Nur eine Abhängigkeit kann zur Zusage werden.',
  'itemErrors.promise.pendingApproval':
    'Diese Abhängigkeit wartet noch auf Zustimmung. Nimm sie zuerst an.',
  'itemErrors.promise.noRequesterToOwn':
    'Diese Aufgabe hat keine Verantwortlichen, denen die Zusage gehören kann. Setze zuerst Verantwortliche ein.',
  'itemErrors.promise.noRequesterToAsk':
    'Die Abhängigkeit hat keine Verantwortlichen, die du fragen kannst. Wähle, wem du die Zusage anbietest.',

  // --- Module fields (src/domain/module-kit.ts) --------------------------------
  'itemErrors.field.unknown': 'Unbekanntes Feld {module}.{field}.',
  'itemErrors.field.derived': '„{label}“ wird berechnet und kann nicht gesetzt werden.',
  'itemErrors.field.singleValue': '„{label}“ hat nur einen Wert.',
  'itemErrors.field.notANumber': '„{label}“ muss eine Zahl sein.',
  'itemErrors.field.belowMin': '„{label}“ muss mindestens {min} sein.',
  'itemErrors.field.aboveMax': '„{label}“ darf höchstens {max} sein.',
  'itemErrors.field.notAllowed': '„{label}“: Dieser Wert ist nicht erlaubt.',
  'itemErrors.field.notADate': '„{label}“ muss ein Datum sein.',
  'itemErrors.field.emptyRef': '„{label}“: leerer Verweis.',
  'itemErrors.field.wrongRefKind': '„{label}“: muss auf {kinds} verweisen.',
  'itemErrors.field.collectionNotEditable':
    '„{label}“: Felder mit mehreren Zeilen lassen sich noch nicht bearbeiten.',
  'itemErrors.field.notAList': '„{label}“ muss eine Liste sein.',
  'itemErrors.field.duplicateRow': '„{label}“: {rowKey} „{id}“ kommt doppelt vor.',

  // --- Time values (src/domain/time-value.ts) ----------------------------------
  'itemErrors.time.empty': 'Leere Zeitangabe.',
  'itemErrors.time.badRange': 'Unbekannter Zeitraum „{input}“.',
  'itemErrors.time.mixedGrain': 'Ein Zeitraum braucht an beiden Enden dieselbe Genauigkeit.',
  'itemErrors.time.endBeforeStart': 'Ein Zeitraum muss nach seinem Beginn enden.',
  'itemErrors.time.unrecognized':
    'Unbekannte Zeitangabe „{input}“. Versuch 2026-07-15, 2026-W24, 2026-07, 2026-Q3, 2026 oder einen Zeitraum a/b.',
  'itemErrors.time.noOffset':
    'Die Uhrzeit „{input}“ braucht ihren Abstand zu UTC, etwa {input}Z oder {input}+02:00.',

  // --- Qualifying a statement (src/domain/qualified-facts.ts) ------------------
  'itemErrors.qualify.badStance': '„{stance}“ ist keine Art, eine Aussage einzuordnen.',
  'itemErrors.qualify.ownDeclaration':
    'Eine Angabe färbt ihre eigene Aufgabe schon im Namen der Person, die sie gemacht hat. Es gibt nichts zu setzen.',
  'itemErrors.qualify.keyAndWord':
    'Setzen nimmt einen Katalogschlüssel oder ein Wort, nie beides: eine Angabe, ein Name.',
  'itemErrors.qualify.noKey':
    'Setzen nennt den Katalogschlüssel, als den die Aussage gesetzt wird.',
  'itemErrors.qualify.badGrade': '„{grade}“ ist keine Stufe.',
  'itemErrors.qualify.wordNeedsGrade': 'Wer ein Wort setzt, nennt die Stufe, die es bekommt.',
  'itemErrors.qualify.containmentColourless':
    '„Nicht betroffen“ färbt nichts: Es trägt weder Schlüssel noch Stufe.',
  'itemErrors.qualify.ownStatementNotContainable':
    'Die eigenen Aussagen einer Aufgabe kann man setzen und notieren, aber niemand kann sie als nicht betroffen markieren. Das lehnt nur die Weitergabe der Aussage einer anderen Aufgabe ab, nie den Stand der Aufgabe selbst.',

  // --- Tag names (src/domain/item-tags.ts) -------------------------------------
  'itemErrors.tag.nameNeeded': 'Ein Tag braucht einen Namen.',
  'itemErrors.tag.tooLong': 'Ein Tag hat höchstens {max} Zeichen.',
  'itemErrors.tag.emptySegment':
    'Ein Tag-Pfad hat keinen leeren Teil (kein / am Anfang, am Ende oder doppelt).',
  'itemErrors.tag.badCharacters':
    'Ein Tag besteht aus Buchstaben, Ziffern, - und _ in jeder Sprache, verschachtelt mit /.',
  'itemErrors.tag.letterNeeded': 'Ein Tag braucht mindestens einen Buchstaben.',

  // --- Sub-item order (src/domain/rank-order.ts) -------------------------------
  'itemErrors.order.notAChild': 'Diese Aufgabe ist hier keine Unteraufgabe.',
  'itemErrors.order.followsItself': 'Eine Aufgabe kann nicht auf sich selbst folgen.',

  // --- Checklist lines (src/domain/checklist.ts) ------------------------------
  'itemErrors.line.badAct': 'Das ist keine Handlung an einem Punkt.',
  'itemErrors.line.badId': 'Das ist keine Kennung eines Punkts.',
  'itemErrors.line.notFound': 'Dieser Punkt steht nicht auf dieser Liste.',
  'itemErrors.line.textNeeded': 'Ein Punkt braucht einen Text.',
  'itemErrors.line.tooLong': 'Ein Punkt hat höchstens {max} Zeichen.',
  'itemErrors.line.tooMany': 'Eine Liste hat höchstens {max} Punkte.',
  'itemErrors.line.alreadyAdded': 'Dieser Punkt steht schon auf der Liste.',
  'itemErrors.line.textUnchanged': 'Der Punkt lautet schon so.',
  'itemErrors.line.ticked': 'Dieser Punkt ist schon abgehakt.',
  'itemErrors.line.open': 'Dieser Punkt ist nicht abgehakt.',
  'itemErrors.line.nestUnchanged': 'Der Punkt steht schon dort.',
  'itemErrors.line.underItself':
    'Ein Punkt kann nicht unter sich selbst oder einen Punkt unter ihm stehen.',
  'itemErrors.line.tickedNotPromoted': 'Ein abgehakter Punkt wird keine Unteraufgabe.',
  'itemErrors.line.nestedNotPromoted': 'Nur ein Punkt oben in der Liste wird eine Unteraufgabe.',
  'itemErrors.line.nothingToPromote': 'Die Liste hat oben keinen offenen Punkt.',
  'itemErrors.line.notBare':
    'Nur eine Unteraufgabe, die nichts als ihren Titel hat und nur unter dieser Aufgabe steht, kann ein Punkt werden.',

  // --- Override mode (src/domain/elevation.ts) ---------------------------------
  'itemErrors.elevation.unknownLength':
    'Unbekannte Dauer für den Eingriffsmodus „{length}“. Wähle eine von {options}.',
  'itemErrors.elevation.tooLong': 'Der Eingriffsmodus dauert höchstens einen Tag.',
  'itemErrors.elevation.alreadyEnded': 'Dieser Eingriffsmodus ist schon beendet.',
  'itemErrors.elevation.alreadyExpired': 'Dieser Eingriffsmodus ist schon abgelaufen.',

  // --- A queued gesture off the wire (src/domain/resolution/wire.ts) -----------
  'itemErrors.wire.noCommand': 'Ein gespeicherter Schritt nennt keinen Befehl.',
  'itemErrors.wire.notACommand': '„{type}“ ist kein Befehl.',
  'itemErrors.wire.commandMissingField': 'Dem Befehl {type} fehlt {name}.',
  'itemErrors.wire.commandMalformedField': 'Der Befehl {type} hat ein ungültiges {name}.',
  'itemErrors.wire.noTarget': 'Ein gespeicherter Schritt nennt kein Ziel.',
  'itemErrors.wire.badTarget':
    'Ein gespeicherter Schritt nennt weder einen Befehl noch den Wert eines Merkmals.',
  'itemErrors.wire.notAGesture': 'Ein gespeicherter Schritt ist kein gültiger Schritt.',
  'itemErrors.wire.gestureMalformedField':
    'Ein gespeicherter Schritt ({kind}) hat ein ungültiges {name}.',
  'itemErrors.wire.gestureMissingField': 'Einem gespeicherten Schritt ({kind}) fehlt {name}.',
  'itemErrors.wire.unknownKind': 'Ein gespeicherter Schritt nennt eine unbekannte Art.',
  'itemErrors.wire.noSurface': 'Ein gespeicherter Schritt nennt keine Oberfläche.',
  'itemErrors.wire.badExpectation': 'Ein gespeicherter Schritt hat eine ungültige Erwartung.',
  // --- Creating an item (src/server/work-items.ts) -----------------------------
  'itemErrors.item.parentNotFound': 'Übergeordnete Aufgabe nicht gefunden.',
  'itemErrors.create.stageNeedsBoard':
    'Eine neue Aufgabe in einer Phasenspalte braucht einen Platz auf einem Board.',
  'itemErrors.create.boardOtherOrg': 'Das Board gehört zu einer anderen Organisation.',
  'itemErrors.create.boardHasNoStages': 'Dieses Board hat keine Phasenspalten für neue Aufgaben.',
  'itemErrors.create.boardFlowRetired': 'Der Ablauf dieses Boards ist nicht mehr aktiv.',
  'itemErrors.create.noSuchStage': 'Der Ablauf dieses Boards hat keine Phase „{stage}“.',
  'itemErrors.create.groupOtherOrg': 'Die Gruppe gehört zu einer anderen Organisation.',
  'itemErrors.create.parentOtherOrg':
    'Eine Unteraufgabe entsteht in der Organisation ihrer übergeordneten Aufgabe, und die gehört zu einer anderen.',

  // --- Seats and offers (src/server/work-items.ts) -----------------------------
  'itemErrors.seat.replaceOwnerNeedsOwner':
    'Die Verantwortung neu zu besetzen, dürfen nur Verwaltende. Frag sie oder bitte darum, sie zu übernehmen.',
  'itemErrors.seat.alreadyHeld': 'Sie sind dort schon eingesetzt.',
  'itemErrors.seat.alreadyOffered': 'Das ist ihnen schon angeboten.',
  'itemErrors.seat.groupMemberOnly':
    'Um dieses Angebot zu übernehmen, musst du Mitglied der angesprochenen Gruppe sein.',
  'itemErrors.seat.noOfferToYou': 'Dir ist dort nichts angeboten.',
  'itemErrors.seat.noOffer': 'Dafür gibt es kein offenes Angebot.',
  'itemErrors.seat.declineNotYours':
    'Ablehnen dürfen nur die, denen das Angebot gilt (oder ein Mitglied der Gruppe), zurückziehen nur, wer es gemacht hat.',

  // --- Verdicts and closing (src/server/work-items.ts) -------------------------
  'itemErrors.verdict.followUpTitleNeeded': 'Eine Folgeaufgabe braucht einen Titel.',
  'itemErrors.close.noItems': 'Keine Aufgaben zum Abschließen.',
  'itemErrors.close.openWorkUnder':
    'Unter einer Aufgabe in dieser Kette ist noch offene Arbeit. Es wurde nichts abgeschlossen.',
  // --- Relationships (src/server/relationships.ts) -----------------------------
  'itemErrors.relationship.selfRelation': 'Eine Aufgabe kann nicht mit sich selbst verknüpft sein.',
  'itemErrors.relationship.accessToRelate':
    'Um zwei Aufgaben zu verknüpfen, brauchst du Zugriff auf eine von beiden.',
  'itemErrors.relationship.accessTo':
    'Um {verb}, brauchst du Zugriff auf eine der beiden Aufgaben.',
  'itemErrors.relationship.verbRetype': 'die Art der Beziehung zu ändern',
  'itemErrors.relationship.verbChange': 'die Beziehung zu ändern',
  'itemErrors.relationship.cycle': 'Damit entstünde ein Kreis in der Aufteilung.',
  'itemErrors.relationship.cycleNow': 'Damit entstünde jetzt ein Kreis in der Aufteilung.',
  'itemErrors.relationship.exists': 'Diese Beziehung gibt es schon.',
  'itemErrors.relationship.alreadyRequested': 'Diese Beziehung ist schon angefragt.',
  'itemErrors.relationship.notPending': 'Diese Beziehung wartet auf keine Zustimmung.',
  'itemErrors.relationship.acceptNeedsAccess':
    'Annehmen kann nur, wer Zugriff auf die geschützte Seite hat.',
  'itemErrors.relationship.inheritanceOnParentOnly':
    'Nur die Verknüpfung zu einer übergeordneten Aufgabe trägt die Vererbung.',
  'itemErrors.relationship.noShare': 'Diese Beziehung hat keinen Anteil.',
  'itemErrors.relationship.badShare': 'Ein Anteil muss eine Zahl ab null sein.',
  'itemErrors.relationship.parentNotRetypable':
    'Die Beziehung „Teil von“ lässt sich nicht umwandeln. Entferne sie und verknüpfe neu.',
  'itemErrors.relationship.stillPending':
    'Diese Verknüpfung wartet noch auf Zustimmung. Nimm sie zuerst an oder zieh sie zurück.',
  'itemErrors.relationship.alreadyKind': 'Schon diese Art.',
  'itemErrors.relationship.conversionSamePair':
    'Beim Umwandeln bleiben es dieselben zwei Aufgaben.',
  'itemErrors.relationship.alreadyLinkKind': 'Schon diese Art von Verknüpfung.',
  // --- Sections and their fields (src/server/modules.ts) -----------------------
  'itemErrors.module.noSuchFlow': 'Diesen Ablauf gibt es in dieser Organisation nicht.',
  'itemErrors.module.flowArchived':
    'Dieser Ablauf ist archiviert. Seine Felder nehmen keine Werte mehr an.',
  'itemErrors.module.noSuchField': 'Dieses Feld gibt es in diesem Ablauf nicht.',
  'itemErrors.module.privateField':
    'Ein privates Feld eines Ablaufs ist eine Anmerkung, kein Stand der Aufgabe.',
  'itemErrors.module.notAMember':
    'Diese Aufgabe ist nicht in diesem Ablauf. Die Felder eines Ablaufs bekommt eine Aufgabe, wenn sie aufgenommen wird.',
  'itemErrors.module.unknown': 'Unbekannter Abschnitt „{module}“.',
  'itemErrors.module.valueUnchanged': 'Wert unverändert.',
  'itemErrors.module.alreadyAdded': 'Abschnitt schon hinzugefügt.',
  'itemErrors.module.alreadyAbsent': 'Abschnitt schon entfernt.',
  // --- Renaming a tag (src/server/retag.ts) ------------------------------------
  'itemErrors.retag.sameName': 'So heißt es schon.',
  'itemErrors.retag.nothingToEdit': 'Nichts, was du bearbeiten darfst, trägt #{tag}.',
  'itemErrors.retag.tooMany':
    'Ein Umbenennen erreicht höchstens {max} Aufgaben auf einmal. #{tag} steht auf {reach}, die du bearbeiten darfst.',

  // --- The offline replay (src/server/replay.ts) -------------------------------
  'itemErrors.replay.tooMany': 'Ein Nachholen umfasst höchstens {max} Befehle.',
  'itemErrors.replay.rateLimited': 'Zu viele Nachholversuche. Versuch es gleich noch einmal.',
  'itemErrors.replay.noCommand': 'Ein gespeicherter Schritt nennt keinen Befehl.',
  'itemErrors.replay.notAnAct': 'Ein gespeicherter Schritt ist kein gültiger Schritt.',
  'itemErrors.replay.malformedKey': 'Ein gespeicherter Schritt hat einen ungültigen Schlüssel.',
  'itemErrors.replay.noItem': 'Ein gespeicherter Schritt nennt keine Aufgabe.',
  'itemErrors.replay.malformedTime': 'Ein gespeicherter Schritt hat eine ungültige Zeit.',
  'itemErrors.replay.malformedBasis':
    'Ein gespeicherter Schritt hat einen ungültigen Ausgangsstand.',

  // --- Notes on statements (src/server/statement-notes.ts) ---------------------
  'itemErrors.note.episodeGone':
    'Diese Aussage gilt so nicht mehr. Lade neu und notiere zur aktuellen Aussage.',

  // --- Checklist order (setChecklistOrder, src/server/views.ts) ---------------
  'itemErrors.checklist.memberOnly': 'Nur wer zu diesem Board gehört, kann es ändern.',
  // --- Direct assignment rules (src/server/push-rules.ts) ----------------------
  'itemErrors.pushRule.noCommons': 'Es gibt noch keinen gemeinsamen Bereich.',
  'itemErrors.pushRule.noSubject':
    'Eine Regel fürs direkte Einsetzen braucht jemanden, für den sie gilt.',
  'itemErrors.pushRule.groupOwnerOnly':
    'Nur die Verwaltenden einer Gruppe legen fest, wer sie direkt einsetzen darf.',
  'itemErrors.pushRule.selfOnly': 'Nur du legst fest, wer dich direkt einsetzen darf.',
  'itemErrors.pushRule.alreadyDefault': 'Schon auf dem Standardkreis.',
  'itemErrors.pushRule.unchanged': 'Regel unverändert.',

  // --- Override mode, ending it (src/server/elevation.ts) ----------------------
  'itemErrors.elevation.notElevated': 'Der Eingriffsmodus ist gerade nicht eingeschaltet.',

  // --- One gesture, one landing (src/server/event-log.ts) ----------------------
  'itemErrors.gesture.alreadyLanded':
    'Dieser Schritt ist schon angekommen. Es wurde nichts doppelt getan.',

  // --- A statement a client names (src/read/statement-handles.ts) --------------
  'itemErrors.statement.gone':
    'Diese Aussage gilt nicht mehr. Lade neu, um den aktuellen Stand zu sehen.',
  'itemErrors.statement.ambiguousCycle':
    'Mehr als ein Kreis dieser Art erreicht diese Aufgabe. Diese Aktion kann sie nicht unterscheiden.',
  'itemErrors.statement.notAStatement': 'Keine Aussage.',

  'itemErrors.attachment.typeRefused': 'Diese Art von Datei wird nicht angenommen.',
  'itemErrors.attachment.tooLarge': 'Diese Datei hat {size}. Die Grenze pro Datei ist {limit}.',
  'itemErrors.attachment.dayExceeded':
    'Mit dieser Datei wäre die Tagesgrenze von {limit} überschritten.',
  'itemErrors.attachment.aliveExceeded':
    'Mit dieser Datei wäre die Gesamtgrenze von {limit} überschritten. Entferne zuerst andere Dateien.',
  'itemErrors.attachment.storeFull': 'Der Speicher hat keinen Platz für diese Datei.',
  'itemErrors.attachment.notFound': 'Diese Datei gibt es nicht.',
  'itemErrors.attachment.off': 'Auf dieser Instanz können keine Dateien hinzugefügt werden.',
  'itemErrors.attachment.imageUnreadable': 'Das Bild konnte nicht gelesen werden.',
  'itemErrors.attachment.empty': 'Die Datei ist leer.',
  'itemErrors.attachment.badName': 'Dieser Dateiname kann nicht verwendet werden.',
  'itemErrors.attachment.busy':
    'Gerade werden zu viele Dateien hochgeladen. Versuch es gleich noch einmal.',
  'itemErrors.attachment.notReceived':
    'Die Datei konnte nicht empfangen werden. Versuch es später noch einmal.',
} as const satisfies AreaCatalog<typeof en>;
